import { useMutation, useQuery } from '@tanstack/react-query';
import { axiosInstance } from '../../utils';
import { IAudioCreation, UploadTypes } from '../../@types';

type Payload = {
  id: string;
  shouldFetchData?: boolean;
};

const getAudioBuildById = async (payload: Payload): Promise<IAudioCreation> => {
  const res = await axiosInstance.get(`/api/audios/audio-build/${payload.id}`);
  return res.data;
};

export const useGetAudioBuildById = (payload: Payload) => {
  return useQuery(['getAudioBuildById', payload], () => getAudioBuildById(payload), {
    enabled: payload?.shouldFetchData,
    keepPreviousData: true,
  });
};
